<template>
  <div
    class="col-sm-12 nopads vehicle-list"
    :class="{ list_closed: !listOpen }"
  >
    <span
      class="vehicle-list-title"
      @click.stop="toggleList"
    >
      {{ $t('sports.work_history') }}
    </span>
    <div
      class="vehicle-list-caret"
      :class="{ caret_open: listOpen }"
      @click.stop="toggleList"
    >
      <font-awesome-icon icon="caret-down" />
    </div>
    <div v-if="listOpen" class="col-sm-12 nopads vehicle-list-container">
      <div class="map-select-item">
        <div v-if="results.length > 0">
          <div
            v-for="item of results"
            :key="item.id"
            class="vehicle-list-item"
            style="cursor: default;"
            @click="$emit('trackClicked', item)"
          >
            <div class="col-12 nopads">
              <div class="vehicle-list-icon">
                <font-awesome-icon
                  :icon="item.added_by ? 'user' : 'route'"
                />
              </div>
              <div class="vehicle-list-header">
                {{ item.track_name ? item.track_name : 'N/A' }}
              </div>
            </div>
            <div
              class="item-detail-text"
              style="font-weight: bold"
            >
              {{ toLocalTime(item.time) }}
            </div>
            <div class="item-detail-text">
              {{ item.task_type_name }}
            </div>
          </div>
        </div>
        <div v-else>
          <span
            v-if="loading"
            class="text-light m-2"
          >
            {{ $t('areas.loading_history') }}
          </span>
          <span
            v-else
            class="text-light m-2"
          >
            {{ $t('areas.no_history') }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {restApi} from '../mixins/RestApiMixin'
import {timeUtils} from '../mixins/TimeUtils'

export default {
    name: 'MapSkiTrackWorkHistory',
    mixins: [restApi, timeUtils],
    data: function () {
        return {
            loading: false,
            results: [],
            listOpen: false
        }
    },
    mounted: function () {
        this.fetchWorkRecords()
    },
    methods: {
        fetchWorkRecords() {
            this.results = []
            this.loading = true
            // TODO - Allow user to choose time range like in vehicle work
            let fromTime = new Date()
            fromTime.setDate(fromTime.getDate() - 30)
            this.restFetchParams(this.skiingTrackWorkUrl, {
                from: this.localTimeToUtcTime(fromTime)
            }, this.success, this.fail)
        },

        success: function (response) {
            this.loading = false
            this.results = response.data
        },

        fail: function () {
            this.loading = false
        },

        toggleList: function () {
            this.listOpen = !this.listOpen
        },

        refreshHistory() {
            this.fetchWorkRecords()
        }

    }
}
</script>
